import { UdfGroup } from '@feature/_app_modules/additional-information/models/UdfGroups';

export class AdditionalInformationWidgetConfiguration {
  AllowedSections: UdfGroup[];
  DefaultSections: UdfGroup[];
}
